import { useQuery } from 'react-query'

import { TarefaService } from '../services/tarefa.service'

export function useTarefas(userId: string | undefined) {
  return useQuery(['dash-todos', { userId }], async () => {
    if (userId) return await TarefaService.getTarefas({ userId })
  })
}
